const API_URL = "https://www.dupaws.com/services/";

import JQuery from "jquery";
import store from "../data/store";
import auth from "../auth";

export default {
  getPetsList() {
    return $.ajax({
      type: "GET",
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "Authorization",
          "bearer " + localStorage.getItem("access_token")
        );
      },
      url: API_URL + "api/getPetsList/",
      dataType: "json",
      crossDomain: true,
      contentType: "application/json; charset=utf-8",
      success: function (data) {
        store.dispatch("PetsList", data);
      },
      error: function (data, status, error) {
        console.log("failed to get Pets List" + data.responseText);
      },
    });
  },
  addSitterToFavorites(sitter) {
    var self = this;
    return $.ajax({
      type: "GET",
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "Authorization",
          "bearer " + localStorage.getItem("access_token")
        );
      },
      url: API_URL + "api/addSitterToFavorites/" + sitter.SitterId,
      dataType: "json",
      crossDomain: true,
      contentType: "application/json; charset=utf-8",
      success: function (data) {
        store.dispatch("FavoriteSitters", data);
        self.notifyAddedFavorite(sitter.SitterId);
      },
      error: function (data, status, error) {
        console.log("Couldn't add sitter to favorites" + data.responseText);
      },
    });
  },

  initFavoriteSitters() {
    return $.ajax({
      type: "GET",
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "Authorization",
          "bearer " + localStorage.getItem("access_token")
        );
      },
      url: API_URL + "api/initFavoriteSitters",
      dataType: "json",
      crossDomain: true,
      contentType: "application/json; charset=utf-8",
      success: function (data) {
        store.dispatch("FavoriteSitters", data);
      },
      error: function (data, status, error) {
        console.log("Couldn't add sitter to favorites" + data.responseText);
      },
    });
  },
  notifyAddedFavorite(sitterId) {
    var self = this;
    $.ajax({
      type: "GET",
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "Authorization",
          "bearer " + localStorage.getItem("access_token")
        );
      },
      url: "https://www.dupaws.com/services/api/addedFavorite/" + sitterId,
      dataType: "json",
      crossDomain: true,
      contentType: "application/json; charset=utf-8",
      success: function (data) {
        console.log(data);
      },
      error: function (data, status, error) {
        console.log(data);
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/services/customerApi.js